import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CoursePlaceholder from "../../../assets/CoursePlaceholder.png";
import { Course } from "../../../types/types";
import QuizXIcon from "../../Icons/QuizXIcon";
import { DeleteCourseFromStudent } from "../../../api/Students/DeleteCourseFromStudent";
import { queryClient } from "../../../main";
import ReactMarkdown from "react-markdown";

const CourseCard = ({ course, studentId }: { course: Course; studentId?: string; }) => {
    const location = useLocation();
    const [showFullDescription] = useState(false);
    const descriptionWords = course.description.split(' ');
    const truncatedDescription = showFullDescription ? descriptionWords.join(' ') : descriptionWords.slice(0, 22).join(' ');
    const { mutate: deleteCourseFromStudent } = useMutation({
        mutationFn: DeleteCourseFromStudent,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["students", "courses"] });
            toast.success("Course deleted from student successfully");
        },
    });
    studentId = studentId || '';

    return (
        <div className="p-4 bg-white rounded-2xl relative border border-black/15">
            <div className="relative mb-4">
                <Link to={`/course/${course.slug}`}>
                    <img
                        className="lg:max-w-[332px] max-h-[225px] w-full h-full object-fit rounded-lg border-[#C4C4C4]/15 border"
                        src={course.img_url || CoursePlaceholder}
                        alt="Course"
                    />
                </Link>
            </div>
            {location.pathname !== "/my-profile" && (
                <button   onClick={() => {
                    if (studentId) {
                      deleteCourseFromStudent({ studentId, courseId: course.id });
                    } else {
                      console.error("Student ID is undefined.");
                    }
                  }}
                
                    className="bg-primary w-5 h-5 flex items-center justify-center rounded-full absolute bottom-2 right-2">
                    <QuizXIcon />
                </button>
            )}
            <div className="flex justify-between w-full items-center mb-3 py-0.5">
                <h1 className="font-semibold md:text-2xl sm:text-xl text-lg">{course?.name}</h1>
            </div>
            <div className="mb-4">
                <span className="font-medium text-sm text-lightGray/70">
                <ReactMarkdown>{truncatedDescription}</ReactMarkdown>
                </span>
                {!showFullDescription && (
                    <Link className="text-sm font-bold text-primary" to={`/course/${course.slug}`}>&nbsp; Learn more about {course.name}</Link>
                )}
            </div>
        </div>
    );
};

export default CourseCard;
